var map = {
	"./agreement/en": "/Gyw",
	"./agreement/en.js": "/Gyw",
	"./agreement/zh-CN": "WnUJ",
	"./agreement/zh-CN.js": "WnUJ",
	"./airTank/en": "KTAa",
	"./airTank/en.js": "KTAa",
	"./airTank/zh-CN": "2W8m",
	"./airTank/zh-CN.js": "2W8m",
	"./course/en": "OePH",
	"./course/en.js": "OePH",
	"./course/zh-CN": "+heH",
	"./course/zh-CN.js": "+heH",
	"./dynamic/en": "n0+D",
	"./dynamic/en.js": "n0+D",
	"./dynamic/zh-CN": "L20x",
	"./dynamic/zh-CN.js": "L20x",
	"./en": "5SxN",
	"./en.js": "5SxN",
	"./evaluation/en": "ZwHW",
	"./evaluation/en.js": "ZwHW",
	"./evaluation/zh-CN": "Hlrg",
	"./evaluation/zh-CN.js": "Hlrg",
	"./home/en": "JZlB",
	"./home/en.js": "JZlB",
	"./home/zh-CN": "w175",
	"./home/zh-CN.js": "w175",
	"./information/en": "XXpy",
	"./information/en.js": "XXpy",
	"./information/zh-CN": "Xp3Y",
	"./information/zh-CN.js": "Xp3Y",
	"./interfaceToast-en": "Yl7d",
	"./interfaceToast-en.js": "Yl7d",
	"./interfaceToast-zh-CN": "z9Ss",
	"./interfaceToast-zh-CN.js": "z9Ss",
	"./login/en": "nRpd",
	"./login/en.js": "nRpd",
	"./login/zh-CN": "BWkq",
	"./login/zh-CN.js": "BWkq",
	"./my/en": "BpGu",
	"./my/en.js": "BpGu",
	"./my/zh-CN": "BkMo",
	"./my/zh-CN.js": "BkMo",
	"./notification/en": "+vpu",
	"./notification/en.js": "+vpu",
	"./notification/zh-CN": "0vJP",
	"./notification/zh-CN.js": "0vJP",
	"./report/en": "+uT4",
	"./report/en.js": "+uT4",
	"./report/zh-CN": "MaQ8",
	"./report/zh-CN.js": "MaQ8",
	"./scale/en": "YdLy",
	"./scale/en.js": "YdLy",
	"./scale/zh-CN": "AsEQ",
	"./scale/zh-CN.js": "AsEQ",
	"./zh-CN": "iW45",
	"./zh-CN.js": "iW45"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LEGu";


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*$
// module id = LEGu
// module chunks = 33